var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExternalLinkIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 8.107,
    height: 8.107,
    viewBox: "0 0 8.107 8.107",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "external-link",
    transform: "translate(-1.5 -1.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_237",
    "data-name": "Path 237",
    d: "M7.986,13.371H2.04V7.29H5.283V6.75H1.5v7.162H8.526V10.128h-.54Z",
    transform: "translate(0 -4.304)",
    fill: "#2b77f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_238",
    "data-name": "Path 238",
    d: "M19.637,1.5v.54h2.32L17.689,6.308l.382.382L22.34,2.423v2.32h.54V1.5Z",
    transform: "translate(-13.273)",
    fill: "#2b77f9"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExternalLinkIcon);
export default __webpack_public_path__ + "static/media/ExternalLinkIcon.b7e95e1c31d1a1559fb1cfec1f275d4f.svg";
export { ForwardRef as ReactComponent };